import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { coverSrc } from "@/components/agent/ProductCard";
import { LicenseKey, AssetList } from "@/pages/ProductDetail";
import { Icon } from "@/lib/icons";
import { api, fmtDate } from "@/lib/api";

export const LibraryProducts = () => {
  const { data = [], isLoading } = useQuery({ queryKey: ["library-products"], queryFn: async () => (await api.get("/library/products")).data });
  if (isLoading) return <div className="h-px bg-white/10 thinking-beam" />;
  if (!data.length) return (
    <div className="border border-dashed border-white/15 p-12" data-testid="library-products-empty">
      <p className="font-display text-2xl font-bold">Sin modelos ni software todavía.</p>
      <div className="mt-5 flex gap-3"><Link to="/models" className="btn-primary">Modelos locales</Link><Link to="/software" className="btn-ghost">Software</Link></div>
    </div>
  );
  return (
    <div className="grid gap-px border border-white/10 bg-white/10 lg:grid-cols-2">
      {data.map(({ product: p, purchase: pu }) => (
        <div key={p.product_id} className="space-y-4 bg-[#080808] p-6" data-testid={`library-product-${p.product_id}`}>
          <div className="flex items-start gap-4">
            <div className="grid h-14 w-20 shrink-0 place-items-center overflow-hidden border border-white/10" style={{ background: `${p.color}14` }}>
              {coverSrc(p) ? <img src={coverSrc(p)} alt="" className="h-full w-full object-cover" /> : <Icon name={p.icon} size={24} style={{ color: p.color }} />}
            </div>
            <div className="min-w-0 flex-1">
              <Link to={`/product/${p.product_id}`} className="font-display text-lg font-bold hover:underline">{p.name}</Link>
              <p className="text-xs text-zinc-500">{p.kind === "model" ? "Modelo local" : "Software"} · v{p.version} · {fmtDate(pu.created_at)}</p>
            </div>
          </div>
          {pu.license_key && <LicenseKey value={pu.license_key} />}
          <AssetList productId={p.product_id} assets={p.assets} />
        </div>
      ))}
    </div>
  );
};
